/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    position: PropTypes.oneOf(['left', 'right', 'center']),
};

const defaultProps = {
    ...commonDefaultProps,
    position: 'left',
};

const ButtonContainer = (props) => {
    const classNames = [
        'c-grid__row c-grid__row--no-col',
        props.position === 'right' ? 'c-grid__row--align-right' : '',
        props.position === 'center' ? 'c-grid__row--align-hcenter' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

ButtonContainer.propTypes = propTypes;

ButtonContainer.defaultProps = defaultProps;

export default ButtonContainer;
